/**
 * Filled magnifying glass — the "active search" counterpart to Heroicons'
 * outline `MagnifyingGlassIcon` (Heroicons' solid magnifier is a hollow ring,
 * so it reads identically to the outline). Geometry matches the Heroicons
 * outline magnifier (lens centred at 10.5,10.5 r7.5, handle to 21,21) so the
 * outline→filled swap looks like the same icon filling in. Colour via
 * `text-*` (uses currentColor), like the highlighter icon.
 */
export const SearchSolidIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="10.5" cy="10.5" r="7.5" fill="currentColor" />
    <path d="m21 21-5.196-5.196" />
  </svg>
);
